export const MESSAGE_FILE_PROCESSING = 'Processing...';

export enum S3FileStatus {
  NEW = 'NEW',
  CLEAN = 'CLEAN',
  INVALID = 'INVALID',
  UNKNOWN = 'UNKNOWN',
}
export const MESSAGE_INVALID_FILE = 'Validation failed';
